import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  updateDynamicSpaceAPI,
  deleteDynamicSpaceAPI,
  getDynamicSpacesAPI,
  createDynamicSpaceAPI,
} from "api/dynamicSpaceApi";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    },
  );
};

const initialState = {
  dynamicSpaces: [],
  loading: false,
  placeId: "",
};

/* ---------------- CREATE DYNAMIC SPACE ---------------- */

export const createDynamicSpace = createAsyncThunk(
  "dynamicSpace/createDynamicSpace",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createDynamicSpaceAPI(data);
      return response.data;
    } catch (err) {
      console.log("createDynamicSpace err ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  },
);

/* ---------------- GET DYNAMIC SPACES ---------------- */

export const getDynamicSpaces = createAsyncThunk(
  "dynamicSpace/getDynamicSpaces",
  async (data, { rejectWithValue }) => {
    console.log("data -->",data)
    try {
      const response = await getDynamicSpacesAPI(data);
      return response.data;
    } catch (err) {
      console.log("getDynamicSpaces err ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  },
);

/* ---------------- DELETE / STATUS UPDATE ---------------- */

export const deleteDynamicSpace = createAsyncThunk(
  "dynamicSpace/deleteDynamicSpace",
  async (data, { rejectWithValue }) => {
    try {
      const response = await deleteDynamicSpaceAPI(data);
      return response.data;
    } catch (err) {
      console.log("deleteDynamicSpace err ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  },
);

/* ---------------- UPDATE DYNAMIC SPACE ---------------- */

export const updateDynamicSpace = createAsyncThunk(
  "dynamicSpace/updateDynamicSpace",
  async (updateData, { rejectWithValue }) => {
    try {
      const response = await updateDynamicSpaceAPI(updateData);
      return response.data;
    } catch (err) {
      console.log("updateDynamicSpace err ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  },
);

/* ---------------- SLICE ---------------- */

export const dynamicSpaceSlice = createSlice({
  name: "dynamicSpaces",
  initialState,
  reducers: {
    setDynamicSpaces: (state, action) => {
      state.dynamicSpaces = action.payload;
    },
    setPlaceIdForDynamicSpaces: (state, action) => {
      state.placeId = action.payload;
    },
  },

  extraReducers: (builder) =>
    builder

      /* GET */

      .addCase(getDynamicSpaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDynamicSpaces.fulfilled, (state, { payload }) => {
        console.log("payload ====>",payload)
        state.dynamicSpaces = payload?.data || [];
        state.loading = false;
      })
      .addCase(getDynamicSpaces.rejected, (state) => {
        state.loading = false;
      })

      /* CREATE */

      .addCase(createDynamicSpace.fulfilled, (state, { payload }) => {
        if (payload?.data) {
          state.dynamicSpaces = [...state.dynamicSpaces, ...payload.data];
        }
      })

      /* UPDATE */

      .addCase(updateDynamicSpace.fulfilled, (state, { payload }) => {
        const updated = payload?.data;

        if (updated) {
          const index = state.dynamicSpaces.findIndex(
            (item) => item._id === updated._id,
          );

          if (index !== -1) {
            state.dynamicSpaces[index] = updated;
          }
        }
      })


      .addCase(deleteDynamicSpace.fulfilled, (state, { payload }) => {
        const deletedId = payload?.data?._id;

        if (deletedId) {
          state.dynamicSpaces = state.dynamicSpaces.filter(
            (item) => item._id !== deletedId,
          );
        }
      }),
});

export const { setDynamicSpaces, setPlaceIdForDynamicSpaces } =
  dynamicSpaceSlice.actions;

export default dynamicSpaceSlice.reducer;
